import _extends from "@babel/runtime/helpers/extends";
import React, { lazy } from "react";

// Stores components
const StoresBoxText = lazy(() => import("./Stores/boxText"));
const StoresBoxImageMiddle = lazy(() => import("./Stores/boxImageMiddle"));
const StoresSlider = lazy(() => import("./Stores/sliderStores"));
const StoresTopCarousel = lazy(() => import("./Stores/topCarousel"));
const StoresBannerHeader = lazy(() => import("./Stores/bannerHeader"));
const AllStoresCarousel = lazy(() => import("./Stores/allStoresCarousel"));

// Product detail components
const ProductPageBannerTop = lazy(() => import("./ProductDetail/productPageBannerTop"));
const ProductPageSiAbbinaConTutto = lazy(() => import("./ProductDetail/ProductPageSiAbbinaConTutto"));
const ProductPageBannerMiddle = lazy(() => import("./ProductDetail/productPageBannerMiddle"));
const ProductPageBannerMiddle2 = lazy(() => import("./ProductDetail/ProductPageBannerMiddle2"));
const ProductPageBannerMiddle3 = lazy(() => import("./ProductDetail/productPageBannerMiddle3"));

// Homepage components
const Presignature = lazy(() => import("./Homepage/presignature"));
const HomepageBannerMiddle = lazy(() => import("./Homepage/bannerMiddle"));
const HomepageBannerMiddleSingleImage = lazy(() => import("./Homepage/bannerMiddleSingleImage"));
const HomepageBannerImageMiddle = lazy(() => import("./Homepage/bannerImageMiddle"));
const HomepageCarbs = lazy(() => import("./Homepage/carbs"));
const HomepageSliderFull = lazy(() => import("./Homepage/sliderTop"));

// Product takeaway components
const ProductPageInfoExtra = lazy(() => import("./ProductTakeaway/ProductPageInfoExtra"));

// Product page CMS components
const ProductPageCMSImagePlusCTA = lazy(() => import("./ProductPageCMSImagePlusCTA/productPageCMSImagePlusCTA"));

// This is the component that renders widgets
/**
 *
 * @param {{
 *  metadata_json:string,
 *  widget_type:string,
 *  category: any,
 *  hideCategory?: boolean
 * }} props
 * @returns {React.ReactNode}
 */
export default function Widget(_ref) {
  let {
    metadata_json,
    widget_type,
    category,
    hideCategory
  } = _ref;
  let Component = null;
  switch (widget_type) {
    case "Reply\\Store\\Block\\Widget\\RistorantiBoxTitoloTestoCTATop":
      Component = StoresBoxText;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiBoxTitoloTestoCTAMiddle":
      Component = StoresBoxText;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiBannerTestoImmagineSfondo":
      Component = StoresBoxImageMiddle;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiBoxTitoloTestoCTABottom":
      Component = StoresBoxText;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiCarouselMiddle":
      Component = StoresSlider;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiCarouselTop":
      Component = StoresTopCarousel;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiPageBannerTopImgTitle":
      Component = StoresBannerHeader;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiPageBoxTitoloTestoCTATop":
      Component = StoresBoxText;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiPageCarousel":
      Component = AllStoresCarousel;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageBannerTop":
      Component = ProductPageBannerTop;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageInfoExtraSiAbbinaConTutto":
      Component = ProductPageSiAbbinaConTutto;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageBannerMiddleTopBottomImage":
      Component = ProductPageBannerMiddle2;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageBannerMiddle2TopImage":
      Component = ProductPageBannerMiddle;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageBannerMiddle3LeftRightImageText":
      Component = ProductPageBannerMiddle3;
      break;
    case "Reply\\Homepage\\Block\\Widget\\Presignature":
      Component = Presignature;
      break;
    case "Reply\\Homepage\\Block\\Widget\\CucinaTuDoppia":
      Component = HomepageBannerMiddle;
      break;
    case "Reply\\Homepage\\Block\\Widget\\CucinaTuSingola":
      Component = HomepageBannerMiddleSingleImage;
      break;
    case "Reply\\Homepage\\Block\\Widget\\BannerImageMiddle":
      Component = HomepageBannerImageMiddle;
      break;
    case "Reply\\Homepage\\Block\\Widget\\Carbs":
      Component = HomepageCarbs;
      break;
    case "Reply\\Homepage\\Block\\Widget\\HomeTopCarousel":
      Component = HomepageSliderFull;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageInfoExtra":
      Component = ProductPageInfoExtra;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageCMSImagePlusCTA":
      Component = ProductPageCMSImagePlusCTA;
      break;
    default:
      return null;
  }
  const metadata = JSON.parse(metadata_json);

  // Pass the parsed JSON as props to the right component
  return /*#__PURE__*/React.createElement(Component, _extends({
    category: category
  }, metadata, {
    hideCategory
  }));
}